import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/veteran-facing-services-tools/veteran-facing-services-tools/packages/documentation/src/layouts/SidebarLayout.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "running-tests"
    }}>{`Running tests`}</h1>
    <p>{`You can run the following types of tests when building on VA.gov.`}</p>
    <h2 {...{
      "id": "prerequisite"
    }}>{`Prerequisite`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/veteran-facing-services-tools/getting-started/common-tasks/run-build"
        }}>{`Run or build`}</a>{` the application.`}</li>
    </ul>
    <h2 {...{
      "id": "test-commands"
    }}>{`Test commands`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Test type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Test all`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Test one`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Requires local build to run`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Test target`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Modules used`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Unit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yarn test:unit`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yarn test:unit ./PATH-TO-TEST-FILE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*.unit.spec.js(x)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://mochajs.org/"
            }}>{`Mocha`}</a>{`, `}<a parentName="td" {...{
              "href": "http://chaijs.com/"
            }}>{`Chai`}</a>{`, `}<a parentName="td" {...{
              "href": "https://sinonjs.org/"
            }}>{`Sinon`}</a>{`, `}<a parentName="td" {...{
              "href": "https://github.com/jsdom/jsdom"
            }}>{`JSDom`}</a>{`, `}<a parentName="td" {...{
              "href": "https://airbnb.io/enzyme/"
            }}>{`Enzyme`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Lint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yarn lint`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yarn lint:js`}</inlineCode>{` or `}<inlineCode parentName="td">{`yarn lint:sass`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*.js`}</inlineCode>{`, `}<inlineCode parentName="td">{`*.scss`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://eslint.org/"
            }}>{`ESLint`}</a>{`, `}<a parentName="td" {...{
              "href": "https://prettier.io/"
            }}>{`Prettier`}</a>{`, `}<a parentName="td" {...{
              "href": "https://github.com/sasstools/sass-lint"
            }}>{`sass-lint`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`End to end`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yarn test:e2e`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yarn test:e2e ./PATH-TO-TEST-FILE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`*.e2e.spec.js`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "http://nightwatchjs.org/"
            }}>{`Nightwatch.js`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Accessibility`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`yarn test:accessibility`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`all pages in `}<inlineCode parentName="td">{`sitemap.xml`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "http://nightwatchjs.org/"
            }}>{`Nightwatch.js`}</a></td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "requires-local-build-or-run"
    }}>{`Requires local build or run`}</h2>
    <p>{`Some tests require `}<a parentName="p" {...{
        "href": "/veteran-facing-services-tools/getting-started/common-tasks/run-build"
      }}>{`running or building`}</a>{` VA.gov:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Testing while running `}<inlineCode parentName="strong">{`watch`}</inlineCode>{` task`}</strong>{`: Tests will automatically be run against the site running on that server.`}</li>
      <li parentName="ul"><strong parentName="li">{`Testing with a local build`}</strong>{`: If nothing is running at `}<inlineCode parentName="li">{`http://localhost:3001`}</inlineCode>{` (`}<inlineCode parentName="li">{`vets-website`}</inlineCode>{` testing) or, `}<inlineCode parentName="li">{`http://localhost:3002`}</inlineCode>{` (`}<inlineCode parentName="li">{`content-build`}</inlineCode>{` testing), tests start an Express server and serve the build output in `}<inlineCode parentName="li">{`build/localhost`}</inlineCode>{`.`}</li>
    </ul>
    <h2 {...{
      "id": "unit-tests"
    }}>{`Unit tests`}</h2>
    <div className="deprecation-message">
    <h3>We're moving our docs!</h3>
    <h4>Find <a href="https://depo-platform-documentation.scrollhelp.site/developer-docs/Unit-tests.1836187655.html">the latest version of this section</a> on the Platform website.</h4>
    <h4>Still can't find what you're looking for? Reach out to <a href="https://dsva.slack.com/archives/CBU0KDSB1">#vfs-platform-support</a> on Slack.</h4>
    </div>
    <ul>
      <li parentName="ul">{`Run all `}<a parentName="li" {...{
          "href": "https://mochajs.org/"
        }}>{`Mocha`}</a>{`/`}<a parentName="li" {...{
          "href": "http://chaijs.com/"
        }}>{`Chai`}</a>{`/`}<a parentName="li" {...{
          "href": "https://sinonjs.org/"
        }}>{`Sinon`}</a>{`-based unit tests with the file extension `}<inlineCode parentName="li">{`.unit.spec.js(x)`}</inlineCode></li>
      <li parentName="ul">{`Use `}<a parentName="li" {...{
          "href": "https://github.com/jsdom/jsdom"
        }}>{`JSDom`}</a>{` and `}<a parentName="li" {...{
          "href": "https://airbnb.io/enzyme/"
        }}>{`Enzyme`}</a>{` to test browser and React behavior`}</li>
      <li parentName="ul">{`Are located in `}<inlineCode parentName="li">{`test/`}</inlineCode>{` directories near the code they're testing in `}<inlineCode parentName="li">{`src/`}</inlineCode></li>
    </ul>
    <h2 {...{
      "id": "linting"
    }}>{`Linting`}</h2>
    <ul>
      <li parentName="ul">{`Verify consistency of JavaScript`}</li>
      <li parentName="ul">{`Enforce code formatting rules`}</li>
      <li parentName="ul">{`Automatically run on `}<inlineCode parentName="li">{`git commit`}</inlineCode>{` as a precommit hook`}</li>
    </ul>
    <p>{`Set up your editor to show ESLint errors automatically as you're writing code. This makes the linter far less annoying in day to day use. ESLint has `}<a parentName="p" {...{
        "href": "https://eslint.org/docs/user-guide/integrations"
      }}>{`integrations`}</a>{` for nearly all popular editors.`}</p>
    <h2 {...{
      "id": "end-to-end-tests"
    }}>{`End to end tests`}</h2>
    <ul>
      <li parentName="ul">{`Run all `}<a parentName="li" {...{
          "href": "http://nightwatchjs.org/"
        }}>{`Nightwatch.js`}</a>{` tests in headless Chrome with the file extension `}<inlineCode parentName="li">{`.e2e.spec.js`}</inlineCode></li>
      <li parentName="ul">{`Simulate an actual user completing tasks in the tools and services`}</li>
      <li parentName="ul">{`Are located in `}<inlineCode parentName="li">{`test/`}</inlineCode>{` directories near the application they're testing in `}<inlineCode parentName="li">{`src/`}</inlineCode></li>
    </ul>
    <p>{`End to end tests will only pass if they are run against their mock API server. This server is started by the end to end test automatically when vets-api is `}<strong parentName="p">{`not`}</strong>{` running.`}</p>
    <h2 {...{
      "id": "accessibility-tests"
    }}>{`Accessibility tests`}</h2>
    <ul>
      <li parentName="ul">{`A variation of e2e tests that run aXe against the content pages running in Chrome.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      